import React from 'react'
import Achievements from './components/Achievements'
import PersonalData from './components/PersonalData'
import OtherSettings from './components/OtherSettings'

const GeneralDataContent = ({
  profileData,
  setIsGeneralModalOpen,
  achievements,
  setIsChangePasswordModalOpen,
}) => {
  return (
    <div className="sm:rounded sm:p-5 border border-brd-primary overflow-hidden overflow-x-hidden mt-[10px] mb-[20px] relative w-full !min-h-[80vh] bg-secondary-background rounded p-[10px]">
      <div className="flex flex-col h-full w-full gap-5 justify-between">
        <PersonalData
          setIsGeneralModalOpen={setIsGeneralModalOpen}
          profileData={profileData}
        />
        <Achievements achievements={achievements} />
        <OtherSettings
          setIsChangePasswordModalOpen={setIsChangePasswordModalOpen}
        />
      </div>
    </div>
  )
}

export default GeneralDataContent
